import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationFR from './locales/fr/translation.json';
import translationES from './locales/es/translation.json';
import translationEN from './locales/en/translation.json';

// Configure the resources
const resources = {
    fr: {
        translation: translationFR
    },
    es: {
        translation: translationES
    },
    en: {
        translation: translationEN
    }
};

i18n
    // Detect user language automatically
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next
    .init({
        resources,
        fallbackLng: 'en', // Use English as the fallback language

        // Have a common namespace used around the full app
        ns: ['translation'],
        defaultNS: 'translation',

        interpolation: {
            escapeValue: false, // React already safe from xss
        },

        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'],
        },
        debug: false
    });

export default i18n;
